import { Tab, Tabs } from "@mui/material";
import withStyles from "@mui/styles/withStyles";

const StyledTabs = withStyles({
  root: {
    padding: "0 0.938rem",
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
  },
  indicator: {
    backgroundColor: "black",
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    minWidth: 0,
    color: "black",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginLeft: theme.spacing(0.2),
    marginRight: theme.spacing(0.2),
    lineHeight: "1.25rem",
    minHeight: "1.25rem",
    "&:focus": {
      opacity: 1,
    },
  },
  selected: {
    pointerEvents: "none",
  },
}))((props) => <Tab disableRipple {...props} />);

const HeaderTabs = ({ tabs = [], disabled, value, onChange }) => {
  return (
    <StyledTabs value={value} onChange={onChange}>
      {tabs.map((tab, index) => (
        <StyledTab
          style={disabled ? { pointerEvents: "none" } : {}}
          key={index}
          data-testid={tab.dataTestId}
          label={tab.label}
          sentryId={tab.sentryId}
        />
      ))}
    </StyledTabs>
  );
};

export default HeaderTabs;
